// components
import GridPageAbstract from '../../GridPageAbstract';
import { TagUserBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';
import React from 'react';
import AudienceListDialog from '../../dialogs/AudienceListDialog';
import UploadCsvDialog from '../../dialogs/UploadCsvDialog';
import { 
    AddCircleWhiteLinearIcon, 
    Edit1LinearIcon,
    TrashErrorLinearIcon 
} from '../../../icons-lib';
import { CloudUpload } from '@mui/icons-material';
import i18n from '../../../i18';
import { MenuItem } from '@mui/material';

export default class MarketingAudiencesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'marketingAudiences';
        this.Server = this.props.context.getState().server.marketingAudiences;
        this.hideSearch = false;
        this.searchFields = ['name'];

        this.headerStartIcon = TagUserBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.hiddenColumns = config?.hiddenColumns?.partners || [];

        // Override the default add action
        this.hideAddAction = true;
        this.hideEditAction = true;
        
        // Ensure menu is shown
        this.MenuDisplayType = 'menu';

        this.state = {
            ...this.state,
            audienceDialogOpen: false,
            audienceDialogData: null,
            uploadCsvDialogOpen: false,
            walletNumbers: [] // Store wallet numbers from CSV
        };

        this.Head = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Text'
            },
            {
                id: 'type',
                label: 'type',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Select',
                filterOptions: [
                    { value: 'STATIC', label: 'Static' },
                    { value: 'ACTIVE', label: 'Active' }
                ],
                renderValue: (value) => {
                    switch (value) {
                    case 'STATIC': return 'Static';
                    case 'ACTIVE': return 'Active';
                    default: return value;
                    }
                }
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Text'
            },
            {
                id: 'usersCount',
                label: 'usersCount',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
        
    }

    // Override getHeaderActions to add the New Audience List button
    getHeaderActions = () => {
        return [
            {
                title: 'Add Audience List',
                icon: <AddCircleWhiteLinearIcon />,
                onClick: () => window.open('http://34.59.62.141:3000/dashboard/2-css-clients', '_blank')
            },
            {
                title: 'Upload CSV',
                icon: <CloudUpload />,
                onClick: () => this.handleOpenUploadCsvDialog()
            }
        ];
    };

    async componentDidMount() {
        await super.componentDidMount();
        
    }

    handleOpenAudienceDialog = (data = null, walletNumbers = null) => {
        this.setState({
            audienceDialogOpen: true,
            audienceDialogData: data,
            walletNumbers: walletNumbers || this.state.walletNumbers
        });
    };

    handleCloseAudienceDialog = () => {
        this.setState({
            audienceDialogOpen: false,
            audienceDialogData: null,
            walletNumbers: [] // Clear wallet numbers when closing dialog
        });
    };

    handleSaveAudience = async (audienceData) => {
        try {
            let response;
            
            // Check if we have wallet numbers from CSV upload
            if (audienceData.walletNumbers && audienceData.walletNumbers.length > 0) {
                // Send data to CSV upload endpoint
                const csvUploadData = {
                    name: audienceData.name,
                    description: audienceData.description,
                    type: audienceData.type,
                    walletNumbers: audienceData.walletNumbers
                };
                
                response = await fetch('/api/audience-lists/upload_csv', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-Token': localStorage.token,
                        'Language': localStorage.language || config.language,
                        'Accept-Language': localStorage.language || config.language,
                    },
                    body: JSON.stringify(csvUploadData)
                });
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const result = await response.json();
                
                if (result.error === 'OK' || result.success) {
                    // Success - refresh the list
                    await this.retrieveData();
                    
                    // Show detailed response from backend if available
                    let message;
                    
                    if (result.data) {
                        // Backend returned detailed statistics
                        message = result.data;
                    } else if (result.message) {
                        // Backend returned a message
                        message = result.message;
                    } else {
                        // Fallback to default message
                        message = i18n.t('messages.audienceCreatedWithCsv');
                    }
                    
                    this.props.context.update({
                        alertError: {
                            message: message,
                            type: 'snackbar',
                            status: 'success'
                        }
                    });
                } else {
                    throw new Error(result.message || 'CSV upload failed');
                }
            } else {
                // Regular audience creation/update without CSV
                if (audienceData.id) {
                    // Update existing audience
                    response = await this.Server.update(audienceData.id, audienceData);
                } else {
                    // Create new audience
                    response = await this.Server.add(audienceData);
                }

                if (response.error === 'OK') {
                    // Success - refresh the list
                    await this.retrieveData();
                    
                    this.props.context.update({
                        alertError: {
                            message: audienceData.id 
                                ? i18n.t('messages.audienceUpdatedSuccess')
                                : i18n.t('messages.audienceCreatedSuccess'),
                            type: 'snackbar',
                            status: 'success'
                        }
                    });
                } else {
                    // Error
                    this.props.context.update({
                        alertError: {
                            message: response.error || i18n.t('messages.audienceSaveError'),
                            type: 'snackbar',
                            status: 'error'
                        }
                    });
                }
            }
        } catch (error) {
            this.props.context.update({
                alertError: {
                    message: error.message || i18n.t('messages.audienceSaveError'),
                    type: 'snackbar',
                    status: 'error'
                }
            });
        }
    };

    handleOpenUploadCsvDialog = () => {
        this.setState({
            uploadCsvDialogOpen: true
        });
    };

    handleCloseUploadCsvDialog = () => {
        this.setState({
            uploadCsvDialogOpen: false
        });
    };

    handleUploadCsv = async (walletNumbers) => {
        try {
            // Store wallet numbers from CSV validation
            this.setState({ 
                walletNumbers: walletNumbers,
                uploadCsvDialogOpen: false 
            });
            
            // Open Add Audience List dialog with wallet numbers
            this.handleOpenAudienceDialog(null, walletNumbers);
            
        } catch (error) {
            throw new Error(error.message || i18n.t('messages.errorUploadingCsv'));
        }
    };

    handleEditItem = (itemId) => {
        // Find the item to edit
        const itemToEdit = this.List.find(item => item.id === itemId);
        if (itemToEdit) {
            this.handleOpenAudienceDialog(itemToEdit);
        }
    };

    handleDeleteItem = async (itemId) => {
        try {
            // The delete method expects an array of IDs, not a single ID
            const response = await this.Server.delete([itemId]);
            
            if (response.error === 'OK') {
                // Success - refresh the list
                await this.retrieveData();
                
                this.props.context.update({
                    alertError: {
                        message: i18n.t('messages.audienceDeletedSuccess'),
                        type: 'snackbar',
                        status: 'success'
                    }
                });
            } else {
                // Error
                this.props.context.update({
                    alertError: {
                        message: response.error || i18n.t('messages.audienceDeleteError'),
                        type: 'snackbar',
                        status: 'error'
                    }
                });
            }
        } catch (error) {
            console.error('Error deleting audience:', error);
            this.props.context.update({
                alertError: {
                    message: i18n.t('messages.audienceDeleteError'),
                    type: 'snackbar',
                    status: 'error'
                }
            });
        }
    };

    renderCustomMenuItems() {
        const currentItemId = this.state.menuClickItemId;
        
        // Force show all menu items
        // because the permissions system does not work correctly
        const items = [
            <MenuItem
                key="edit"
                onClick={() => {
                    this.handleCloseMenu();
                    this.handleEditItem(currentItemId);
                }}
            >
                <Edit1LinearIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.edit')}
            </MenuItem>,
            <MenuItem
                key="delete"
                onClick={() => {
                    this.handleCloseMenu();
                    this.handleDeleteItem(currentItemId);
                }}
            >
                <TrashErrorLinearIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.delete')}
            </MenuItem>
        ];
        
        return items;
        

    }

    hasMenuItems() {
        // Force show menu for this page
        // because the permissions system returns empty strings
        return true;
        
       
    }

    renderCustom() {
        return (
            <>
                <AudienceListDialog
                    open={this.state.audienceDialogOpen}
                    onClose={this.handleCloseAudienceDialog}
                    onSave={this.handleSaveAudience}
                    data={this.state.audienceDialogData}
                    walletNumbers={this.state.walletNumbers}
                    context={this.props.context}
                />
                <UploadCsvDialog
                    open={this.state.uploadCsvDialogOpen}
                    onClose={this.handleCloseUploadCsvDialog}
                    onUpload={this.handleUploadCsv}
                />
            </>
        );
    }
}
